<template>
  <BaseListContactsPage
    :tabs="tabs"
    :current-tab="currentTab"
    :contacts-selectable="!massTextIcon.disabled"
    :archive-contact="archiveContact"
    :swipe-contact="swipeContact"
    :get-gql-query="getGqlQuery"
    :update-gql-query="updateGqlQuery"
    :running-update-query="runningUpdateQuery"
    :update-query-disabled="queryNewContactDisabled"
    :get-items="getItems"
    :get-total-items-count="getTotalItemsCount"
    :get-query-variables="getQueryVariables"
    :update-query-variables="updateQueryVariables"
    :update-context-variable="updateContextVariable"
    :on-tab-changed="onTabChanged"
    :get-total-contacts="getTotalContacts"
  />
</template>

<script>
import BaseListContactsPage from '@/pages/BaseListContactsPage'
import { mapGetters, mapActions } from 'vuex'
import { contactMapActions } from '@/store/utils'
import CONTACTS_WITH_WORK_QUERY from '@/backend/graphql/contact/ContactsWithWork.gql'
import ACTIVE_CONTACTS_WITH_WORK_QUERY from '@/backend/graphql/contact/ActiveContactsWithWork.gql'
import ACTIVE_CONTACTS_BY_NAME_OR_NUMBER_QUERY from '@/backend/graphql/contact/ActiveContactsByNameOrNumber.gql'

export default {
  name: 'ContactsPage',
  components: { BaseListContactsPage },
  data: function () {
    return {
      getGqlQuery: ACTIVE_CONTACTS_WITH_WORK_QUERY,
      updateGqlQuery: ACTIVE_CONTACTS_BY_NAME_OR_NUMBER_QUERY,
      currentTab: 'tab-1',
      limit: 50,
      offset: 0,
      orderBy: '-last_sms_at,-id',
      isDelete: 0,
      archiveContact: true,
      swipeContact: false,
      tabs: {
        'tab-1': 'Active',
        'tab-2': 'All'
      },
      massTextIconCurrentDisabled: false
    }
  },
  computed: {
    ...mapGetters({
      getMassTextIcon: 'toolBar/getMassTextIcon',
      runningUpdateQuery: 'contact/getQueryingNewContact',
      queryNewContactDisabled: 'contact/getQueryingNewContactDisabled',
      getNewContactByNumberVariables: 'contact/getQueryNewContactByNumberVariables',
      massTextIcon: 'toolBar/getMassTextIcon'
    })
  },
  created () {
    this.currentTab = 'tab-1'
    this.setEditMenuItems({ val: [
      { title: 'Edit Contacts', route: { name: 'editAllContacts' } },
      { title: 'Add Contacts' },
      { title: 'Remove Contacts' }
    ] })
    this.massTextIconCurrentDisabled = this.getMassTextIcon.disabled
  },
  destroyed () {
    if (this.currentTab === 'tab-2') {
      this.setMassTextToggleDisabled({ val: false })
    }
    this.setMassTextIconDisabled({ val: true })
  },
  methods: {
    ...mapActions(Object.assign(contactMapActions, {
      setEditMenuItems: 'toolBar/setEditMenuItems',
      setMassTextToggleDisabled: 'toolBar/setMassTextToggleDisabled',
      setMassTextIconDisabled: 'toolBar/setMassTextIconDisabled',
      setQueryNewContactDisabled: 'contact/setQueryNewContactDisabled'
    })),
    getItems (data) {
      return data.listContacts.results
    },
    getTotalItemsCount (data) {
      return data.listContacts.totalCount
    },
    getQueryVariables () {
      return this.currentTab === 'tab-1' ? {
        limit: this.limit,
        offset: this.offset,
        orderBy: this.orderBy,
        isDelete: 0,
        hasInbox: true
      } : {
        limit: this.limit,
        offset: this.offset,
        orderBy: this.orderBy,
        isDelete: 0
      }
    },
    updateQueryVariables () {
      return this.getNewContactByNumberVariables
    },
    updateContextVariable (key, value) {
      if (this.hasOwnProperty(key)) {
        this[key] = value
      }
    },
    getTotalContacts (value) {
      if (value === this.currentTab) { return this.$store.getters['contact/getTotalCount'] } else { return '?' }
    },
    onTabChanged (value) {
      this.currentTab = value
      this.clearContacts()
      this.offset = 0
      if (this.currentTab === 'tab-1') {
        this.archiveContact = true
        this.setQueryNewContactDisabled({ val: false })
        this.getGqlQuery = ACTIVE_CONTACTS_WITH_WORK_QUERY
        this.orderBy = '-last_sms_at,-id'
        this.setMassTextToggleDisabled({ val: false })
        this.setMassTextIconDisabled({ val: this.massTextIconCurrentDisabled })
      } else {
        this.setQueryNewContactDisabled({ val: true })
        this.archiveContact = false
        this.getGqlQuery = CONTACTS_WITH_WORK_QUERY
        this.orderBy = '-id,-last_sms_at'
        this.setMassTextToggleDisabled({ val: true })
        this.massTextIconCurrentDisabled = this.getMassTextIcon.disabled
        this.setMassTextIconDisabled({ val: true })
      }
    }
  }
}
</script>

<style scoped>
</style>
